import { Component, Input, OnInit } from '@angular/core';
import { AllergenNutritionFlavorService, IAllergen, IAllergenConfig, IFindAllergen, IFindFlavor, IFindNutrition, IFlavor, IFlavorConfig, INutrition, INutritionConfig } from 'src/app/account/services/allergen-nutrition-flavor.service';
import { SettingService } from '../../services/setting.service';
import { ModalController } from '@ionic/angular';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-item-content-details-modal',
  templateUrl: './item-content-details-modal.component.html',
  styleUrls: ['./item-content-details-modal.component.scss'],
  standalone: false
})
export class ItemContentDetailsModalComponent  implements OnInit {

  @Input() contentDisplayType: string = "all";
  @Input() ItemId: string;

  nutritions: INutrition;
  allergens: IAllergen;
  flavors: IFlavor;

  findNutrition: IFindNutrition = {
    merchantId: "",
    deepSearch: true,
    itemIds: [],
    page: 0,
    pageSize: 0
  };

  findAllergen: IFindAllergen = {
    merchantId: "",
    deepSearch: true,
    itemIds: [],
    page: 0,
    pageSize: 0
  };

  findFlavor: IFindFlavor = {
    merchantId: "",
    deepSearch: true,
    itemIds: [],
    page: 0,
    pageSize: 0
  };

  item: any;

  isOpen: boolean = true; // default to true for now

  constructor(
    private allergenNutritionFlavorService: AllergenNutritionFlavorService,
    public settings: SettingService,
    private modalCtrl: ModalController,
    public translationService: TranslationService,
  ) { }

  ngOnInit() {
    /*
    this.getAllNutritions();
    this.getAllAllergens();
    this.getAllFlavors();
    */
   

    // if we want to limit the data pulled uncomment below
    if(this.contentDisplayType == "nutrition") {
      this.getAllNutritions();
    } else if(this.contentDisplayType == "allergen") {
      this.getAllAllergens();
    } else if(this.contentDisplayType == "flavor") {
      this.getAllFlavors();
    } else {
      this.getAllNutritions();
      this.getAllAllergens();
      this.getAllFlavors();
    }
  }

  expandDetails(){
    //temporarily disabled
    /*
    console.log("expand");
    this.isOpen = !this.isOpen
    */
  }

  closePopup(){
    this.modalCtrl.dismiss();
  }

  getNutritionForItem(nutrition: INutritionConfig): number {
    
    for(var i = 0; i < nutrition.itemValues.length; i++) {
      if(this.ItemId == nutrition.itemValues[i].itemId) {
        return nutrition.itemValues[i].value;
      }
    }
  }

  getFlavorsForItem(): string {
    var textAppend = "";
    for(var i = 0; i < this.flavors.flavors.length; i++) {
      const flavorValues = this.flavors.flavors[i].itemValues.find(value => value.itemId == this.ItemId);
      if(flavorValues) {
        
        if(flavorValues.value) {
          if(textAppend == "") {
            textAppend += this.flavors.flavors[i].name.translations[this.translationService.getLanguage()];
          } else {
            textAppend += ", " + this.flavors.flavors[i].name.translations[this.translationService.getLanguage()];
          }
        }
      }
      
    }

    return textAppend;
  }

  getAllNutritions(){
    this.fetchNutritions().subscribe(async nutrition => {
      this.nutritions = nutrition;

      // always gets only 1 item in this particular case
      this.item = this.nutritions.items[0];
    });
  }

  fetchNutritions() {

    this.findNutrition.merchantId = this.settings.getMerchantId();
    this.findNutrition.deepSearch = true;
    this.findNutrition.itemIds = [this.ItemId];
    this.findNutrition.page = 0;
    this.findNutrition.pageSize = 0;
    

    return this.allergenNutritionFlavorService.getNutritions(this.findNutrition);
  }

  getAllAllergens(){
    this.fetchAllergens().subscribe(async allergens => {
      this.allergens = allergens;

      // always gets only 1 item in this particular case
      this.item = this.allergens.items[0];
      console.log(this.allergens);

      console.log(this.item);

      this.getAllergensContainName();
    });
  }

  fetchAllergens() {
    this.findAllergen.merchantId = this.settings.getMerchantId();
    this.findAllergen.deepSearch = true;
    this.findAllergen.itemIds = [this.ItemId];
    this.findAllergen.page = 0;
    this.findAllergen.pageSize = 0;

    return this.allergenNutritionFlavorService.getAllergens(this.findAllergen);
  }

  getAllFlavors(){
    this.fetchFlavors().subscribe(async flavors => {
      this.flavors = flavors;

      // always gets only 1 item in this particular case
      this.item = this.flavors.items[0];
      console.log(this.flavors);

      console.log(this.item);
    });
  }

  fetchFlavors() {
    this.findFlavor.merchantId = this.settings.getMerchantId();
    this.findFlavor.deepSearch = true;
    this.findFlavor.itemIds = [this.ItemId];
    this.findFlavor.page = 0;
    this.findFlavor.pageSize = 0;
    

    return this.allergenNutritionFlavorService.getFlavors(this.findFlavor);
  }


  ////////////////////////////////////////////////////////////////////////////////////
  // nutrition data processing

  getIteNutritionName(itemId: string): string {
    const item = this.nutritions.items.find(i => i.itemId === itemId);
    Math.floor
    return item.item.itemName.translations[this.translationService.getLanguage()];
  }

  getItemNutritionValue(itemId: string, nutrition: INutritionConfig): number {
    const itemData = nutrition.itemValues.find(i => i.itemId === itemId);
    if(itemData) {
      return itemData.value;
    } else {
      return 0; // default value if there's no fields for it from the db
    }
  }

  ////////////////////////////////////////////////////////////////////////////////////
  // allergen data processing

  getItemAllergenName(itemId: string): string { 
    const item = this.allergens.items.find(i => i.itemId === itemId);
    Math.floor
    return item.item.itemName.translations[this.translationService.getLanguage()];
  }

  getItemAllergenValue(itemId: string, allergen: IAllergenConfig): number {
    const itemData = allergen.itemValues.find(i => i.itemId === itemId);
    if(itemData) {
      return itemData.value;
    } else {
      return 0; // default value if there's no fields for it from the db
    }
  }

  getAllergensContainName(): string {
    var allergensListText = "";
    for(var i = 0; i < this.allergens.allergens.length; i++) {
      if(this.allergens.allergens[i].isActive) {
        const itemData = this.allergens.allergens[i].itemValues.find(item => item.itemId === this.item.itemId)
        if(itemData) {
          if(itemData.value == 1) {
            if(allergensListText == "") {
              allergensListText += this.allergens.allergens[i].name.translations[this.translationService.getLanguage()];
            } else {
              allergensListText += ", " + this.allergens.allergens[i].name.translations[this.translationService.getLanguage()];
            }
          }
          
        }
      }
    }

    return allergensListText;
  }

  getAllergensMayContainName(): string {
    var allergensListText = "";
    for(var i = 0; i < this.allergens.allergens.length; i++) {
      if(this.allergens.allergens[i].isActive) {
        const itemData = this.allergens.allergens[i].itemValues.find(item => item.itemId === this.item.itemId)
        if(itemData) {
          if(itemData.value == 2) {
            if(allergensListText == "") {
              allergensListText += this.allergens.allergens[i].name.translations[this.translationService.getLanguage()];
            } else {
              allergensListText += ", " + this.allergens.allergens[i].name.translations[this.translationService.getLanguage()];
            }
          }
          
        }
      }
    }
    return allergensListText;
  }
  ////////////////////////////////////////////////////////////////////////////////////
  // flavor data processing

  getItemFlavorName(itemId: string): string {
    const item = this.flavors.items.find(i => i.itemId === itemId);
    Math.floor
    return item.item.itemName.translations[this.translationService.getLanguage()];
  }

  getItemFlavorValue(itemId: string, flavor: IFlavorConfig): boolean {
    const itemData = flavor.itemValues.find(i => i.itemId === itemId);
    if(itemData) {
      return itemData.value;
    } else {
      return false; // default value if there's no fields for it from the db
    }
  }
  ////////////////////////////////////////////////////////////////////////////////////

  

}
